module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_vm._v("CORRIGENDA TO VOLUME 2")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p.61, line 14: for ‘fiction’s’ read ‘fictitious’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p.27, line 25: for ‘their’ read ‘there’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p.73, line 12 from foot: for ‘or’ read ‘nor’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p.145, line 16: for ‘long before’ read ‘at about the same time as’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p.160, line 26: for ‘or’ read ‘o’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p.161, line 9 from foot: replace quotation by: H. Lévy-Ullmann, "), _c('i', [_vm._v("La Définition du droit")]), _vm._v(" (Paris, 1917), p.165: ‘Nous definirons donc le droit: la délimitation de ce que le hommes et leurs groupements ont la liberté de faire et de ne pas faire, sans encourir une condemnation, une saisie, une mise en jeu particulière de la force.’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p.163, line 21: for ‘d’empecher’ read ‘d’empêcher’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p.176, line 13 from foot: for ‘constitutione’ read ‘costituzione’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("p.187, line 6 from foot: ‘for "), _c('i', [_vm._v("‘Republica’")]), _vm._v(" read "), _c('i', [_vm._v("‘Re Publica’")]), _c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e18a711a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780226321264_09_cor.vue
// module id = 75
// module chunks = 0